import { Controller } from "@hotwired/stimulus";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class extends Controller {
    static targets = ['media', 'mask'];

    tl = gsap.timeline();

    connect() {
        if (!this.mediaTarget || !this.maskTarget) return;

        // Wait for a tiny scroll or 1 second before initializing
        setTimeout(() => {
            this.tl = gsap.timeline({
                scrollTrigger: {
                    trigger: this.mediaTarget,
                    start: "bottom bottom", // Triggers when bottom of media reaches bottom of viewport
                    toggleActions: "play reverse play reverse", // Plays both ways
                    immediateRender: false // Prevents immediate rendering on page load
                }
            });

            // Add the mask animation to the timeline
            this.tl.to(this.maskTarget.querySelector('.animated-hero__media-mask-icon'), {
                scale: 3.275,
                duration: 2,
                transformOrigin: "top center",
                ease: "power2.inOut"
            });
        }, 1000);

    }

}
